<template>
  <v-dialog
    v-model="basketDialogOpen"
    fullscreen
    scrollable
    transition="dialog-right-transition"
    persistent
    :disabled="disabled"
    max-width="1200px"
    @keydown.esc="basketDialogOpen = false"
  >
    <template #activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <slot />
      </span>
    </template>
    <MiniBasketContent :is-mobile="true" @close="basketDialogOpen = false" />
  </v-dialog>
</template>

<script>
import MiniBasketContent from '@/js/components/Basket/Mini/MiniBasketContent.vue'

export default {
  name: 'MiniBasketDialog',
  components: {
    MiniBasketContent,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      basketDialogOpen: false,
    }
  },
}
</script>

<style lang="scss" module></style>
